module.exports = __webpack_public_path__ + "img/instagram-food-button-1.5083281f.png";